import React from 'react';
export function AboutHeader() {
  return <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-383">
      <div className="animate-fade-up-in" data-id="element-384">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-385">
          About <span className="text-[#00D4FF]" data-id="element-386">Walker's</span>
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-387">
          More than just a martial arts school. We are a community dedicated to
          empowering individuals through discipline, respect, and strength.
        </p>
      </div>
    </div>;
}